export interface EditorDeepLink {
    sectionName?: string;
    attributeName?: string;
}

/**
 * `/edit/:pk/section/:name` opens that section. `/attribute/:name` and a
 * trailing name keep the previous "last segment is an attribute" lookup.
 */
export function resolveEditorDeepLink(path: string): EditorDeepLink {
    const pathParts = (path || '').split('/').filter((part) => part.length > 0);
    const sectionMarker = pathParts.lastIndexOf('section');
    const attributeMarker = pathParts.lastIndexOf('attribute');

    if (sectionMarker >= 0 && sectionMarker < pathParts.length - 1) {
        return { sectionName: pathParts[sectionMarker + 1] };
    }
    if (attributeMarker >= 0 && attributeMarker < pathParts.length - 1) {
        return { attributeName: pathParts[attributeMarker + 1] };
    }
    const last = pathParts[pathParts.length - 1];
    return last ? { attributeName: last } : {};
}
